import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import DividerConTitulo from "./DividerConTitulo";
const GoogleSlidesEmbed = ({ embedCode, titulo, mostrarTitulo }) => {
  return (
    <Box sx={{ textAlign: 'center', my: 3 }}>
      {mostrarTitulo && titulo && (
        <DividerConTitulo titulo={titulo} />
      )}
      {/* Mejorar visualización del iframe: redondear bordes */}
      <div
        dangerouslySetInnerHTML={{ __html: embedCode.replace('<iframe ', '<iframe style="border-radius:16px;box-shadow:0 2px 16px rgba(0,0,0,0.08);" ') }}
      />
    </Box>
  );
};

GoogleSlidesEmbed.propTypes = {
  embedCode: PropTypes.string.isRequired,
  titulo: PropTypes.string,
  mostrarTitulo: PropTypes.bool,
};

export default GoogleSlidesEmbed;
